import React, { useState } from "react";
import * as yup from "yup";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import UploadAttachments from "../../../components/uploadAttachments";
import Input from "../../../components/input";
import Button from "../../../components/button";
import { validationSchema } from "../validationSchema";
import { mapContractsToApi } from "../mapContractsToApi";
import Spinner from "../../../components/Spinner";
import Api from "../../../lib/api";
import { FormGroup, FormRow, FormStyle } from "../../../styles/forms/main";
import { ButtonRow, ErrorMessage, ErrorsContainer } from "../../../styles/elements/main";

function CreateContract({ onClose, onSuccess, ownerId, ownerType }) {
    const [newContractData, setNewContractData] = useState({
        contractDocument: null,
        startDate: null,
        endDate: null,
    });
    const [errorList, setErrorList] = useState(null);
    const [errors, setErrors] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const clearContractsData = () => {
        setNewContractData({
            contractDocument: null,
            startDate: null,
            endDate: null,
        });
    };
    const handleNewContractChange = (e, name) => {
        if (!name) {
            const { name, value } = e?.target;
            setNewContractData({
                ...newContractData,
                [name]: value,
            });
            yup.reach(validationSchema, name)
                .validate(value)
                .then(() => setErrorList({ ...errorList, [name]: "" }))
                .catch((err) => setErrorList({ ...errorList, [name]: err.message }));
        } else {
            setNewContractData({
                ...newContractData,
                [name]: e,
            });

            yup.reach(validationSchema, name)
                .validate(e)
                .then(() => setErrorList({ ...errorList, [name]: "" }))
                .catch((err) => setErrorList({ ...errorList, [name]: err.message }));
        }
    };

    const handleSubmitNewContract = async (e) => {
        e.preventDefault();

        try {
            // eslint-disable-next-line no-unused-vars
            const response = await validationSchema
                .validate(newContractData, { abortEarly: false })
                .then(async () => {
                    setIsLoading(true);
                    Api.post(
                        `contracts`,
                        await mapContractsToApi(newContractData, ownerId, ownerType)
                    )
                        .then(() => {
                            setIsLoading(false);
                            onSuccess();
                            clearContractsData();
                            window.location.reload(true);
                        })
                        .catch((error) => {
                            setIsLoading(false);
                            setErrors(error);
                        });
                });
        } catch (error) {
            const errorMessage = error?.inner?.reduce(
                (acc, error) => ({
                    ...acc,
                    [error?.path]: error?.message,
                }),
                {}
            );
            setErrorList(errorMessage);
        }
    };
    return (
        <FormStyle style={{ paddingBottom: "0rem" }}>
            <FormGroup>
                <UploadAttachments
                    label="Contract Document"
                    required
                    isEditable
                    onFilesChange={(e) => handleNewContractChange(e, "contractDocument")}
                    errorMessage={errorList?.contractDocument}
                    maxLength={1}
                />
            </FormGroup>
            <FormRow>
                <FormGroup>
                    <Input
                        type="date"
                        label="Start Date"
                        name="startDate"
                        isEditable
                        required
                        placeholder="DD/MM/YYY"
                        onChange={(e) => handleNewContractChange(e)}
                        value={newContractData?.startDate}
                        errorMessage={errorList?.startDate}
                    />
                </FormGroup>
                <FormGroup>
                    <Input
                        type="date"
                        label="End Date"
                        name="endDate"
                        isEditable
                        required
                        placeholder="DD/MM/YYY"
                        value={newContractData?.endDate}
                        onChange={(e) => handleNewContractChange(e)}
                        errorMessage={errorList?.endDate}
                    />
                </FormGroup>
            </FormRow>
            {errors?.length > 0 && (
                <ErrorsContainer>
                    {errors.map((error, index) => (
                        <ErrorMessage>
                            <WarningAmberOutlinedIcon />
                            {error.detail}
                        </ErrorMessage>
                    ))}
                </ErrorsContainer>
            )}

            <ButtonRow>
                <Button
                    type="button"
                    onChange={onClose}
                    name="Cancel"
                    btnStyle="secondBtn"
                />
                <Button
                    type="submit"
                    name={isLoading ? <Spinner /> : "Add"}
                    onChange={handleSubmitNewContract}
                    btnStyle="primaryBtn"
                    icon={<AddCircleOutlineOutlinedIcon />}
                />
            </ButtonRow>
        </FormStyle>
    );
}

export default CreateContract;
